import Home from 'components/Pages/Home/Home';
import About from 'components/Pages/About/About';
import Project from 'components/Pages/Project/Project';
import Curated from 'components/Pages/Curated/Curated';
import Works from 'components/Pages/Works/Works';
import Term from 'components/Pages/Works/Term';
import Err from 'components/Pages/Err/Err';

import { matchRoutes } from 'react-router-config';

const mapPathnameToAPI = ( pathname ) => {
	const branch = matchRoutes( routes, pathname )[0];
	const params = branch.match.params;
	const apiFormat = branch.route.api || [];
	return apiFormat.map( val => { return (val.charAt(0) !== ':') ? val : params[val.slice(1)] });
}

const mapPathnameToStore = ( pathname ) => {
	const branch = matchRoutes( routes, pathname )[0];
	const params = branch.match.params;
	const storeFormat = branch.route.store || [];
	return storeFormat.map( val => { return (val.charAt(0) !== ':') ? val : params[val.slice(1)] });
}

const routes = [
	{ exact: true, path: "/",                component: Home,    api: ['curateds'],           store: ['archives', 'curated'] }, 
	{ exact: true, path: "/about",           component: About,   api: ['about'],              store: ['page' ,'about'] }, 
	{ exact: true, path: "/works",           component: Works,   api: ['projects'],           store: ['archives', 'all'] }, 
	{ exact: true, path: "/:slug",           component: Project, api: ['projects', ':slug'],  store: ['projects', ':slug'] }, 
	{ exact: true, path: "/curated/:term",   component: Curated, api: ['curateds'],           store: ['archives', 'curated'] }, 
	{ exact: true, path: "/:taxonomy(years|categories|tags)/:term", component: Term,    api: [':taxonomy', ':term'], store: ['archives', ':taxonomy', ':term'] },
	{ component: Err, store: ['noop', 'success'] }, // catch-all
];

export {mapPathnameToAPI, mapPathnameToStore, routes};



// WEBPACK FOOTER //
// ./src/routes.js